import { useEffect } from 'react';
import styles from './LeaderboardPage.module.scss';
import { useQuery } from '@tanstack/react-query';
import { getLeaders } from '@/api/modules/Leaderboard/leaderboard';
import { Loader } from '@/components/Loader/Loader';
import LeadCard from './LeadCard';
import LeaderboardHeader from './LeaderboardHeader/LeaderboardHeader';

const LeaderboardPage = () => {
  const { data, isLoading } = useQuery({
    queryKey: ['leaders'],
    queryFn: getLeaders,
  });

  type Reward = {
    position: number;
    user_id: string;
    amount: number;
    photo_url: string;
    name: string;
    isYou?: boolean;
  };

  // ⬇️ Подключаем contentSafeAreaInset для CSS
  useEffect(() => {
    const tg = (window as any)?.Telegram?.WebApp;
    if (!tg) return;

    const apply = () => {
      const top = tg?.contentSafeAreaInset?.top ?? 0;
      document.documentElement.style.setProperty(
        '--tg-viewport-content-safe-area-inset-top',
        `${top}px`,
      );
    };

    apply();
    tg.onEvent?.('contentSafeAreaChanged', apply);
    return () => tg.offEvent?.('contentSafeAreaChanged', apply);
  }, []);

  return (
    <div
      className={`${styles.container} ${isLoading ? styles.container_loading : ''}`}
    >
      <LeaderboardHeader isLoading={isLoading} />

      {isLoading ? (
        <div className={styles.container__loaderContainer}>
          <Loader />
        </div>
      ) : (
        <div className={styles.container__contentContainer}>
          <div className={styles.container__content}>
            <div className={styles.yourPosition}>
              <LeadCard
                position={data.user.position}
                name={data.user.name}
                rewardNumber={data.user.amount}
                photoUrl={data.user.photo_url}
                isYou={true}
              />
            </div>

            <div className={styles.leaderboardContainer}>
              <div className={styles.leaderboardTitle}>
                Рейтинг лучших участников
              </div>
              <div className={styles.leaderboard}>
                {data.leaders.map((reward: Reward) => (
                  <LeadCard
                    key={reward.user_id}
                    position={reward.position}
                    name={reward.name}
                    rewardNumber={reward.amount}
                    photoUrl={reward.photo_url}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LeaderboardPage;
